import React, { FC } from 'react'

import clsx from 'clsx'

import { Txt } from 'src/components/atoms'
import { SearchRefinementIcon } from 'src/components/molecules'

type Props = {
  isSearchEnabled: boolean
  className?: string
}

export const SearchNarrowDown: FC<Props> = ({ isSearchEnabled, className }) => {
  return (
    <div className={className}>
      <div className="tw-flex tw-items-center tw-gap-s-4">
        <SearchRefinementIcon searchEnabled={isSearchEnabled} />
        <Txt sizeType="s" className={clsx(!isSearchEnabled && 'tw-text-standardText-disable')}>
          絞り込み
        </Txt>
      </div>
    </div>
  )
}
